<template>
  <div>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
    >
      <template #toggler>
        <div>
          <CHeaderNavLink>
            <div class="c-avatar">
              <!-- <img
              src="img/avatars/6.jpg"
              class="c-avatar-img "
              />-->

              <div class="user-icon">
                <div class="user-initials">{{ userInitials }}</div>
              </div>
            </div>
          </CHeaderNavLink>
        </div>
      </template>
      <CDropdownHeader
        tag="div"
        class="text-center"
        style="color: whitesmoke; background-color: #373737"
      >
        <strong>Account</strong>
      </CDropdownHeader>
      <div class="user-details">
        <span class="username">{{ username }}</span>
        <br />
        <span class="user-email">{{ user.email }}</span>
      </div>
      <!-- CCR User Tools -->
      <div v-if="user.Contact_Company_RecID == 2">
        <div class="dropdown-divider">
          <div class="dividerText">CCR Management</div>
        </div>
        <CDropdownItem class="CompanySelectBox">
          <DxSelectBox
            v-if="user.Contact_Company_RecID == 2"
            ref="selectBusiness"
            :data-source="companyList"
            placeholder="Select a business"
            value-expr="Company_RecID"
            display-expr="Company_Name"
            :value="user.Company_RecID"
            :onSelectionChanged="changeCompany"
            :disabled="user.Contact_RecID == 49401"
          />
        </CDropdownItem>
        <CDropdownItem
          @click.prevent="showUsersModal = true"
          class="custom-dark"
        >
          <CIcon name="cil-user" />Manage Access
        </CDropdownItem>
        <CDropdownItem
          @click.prevent="ShowUserBack"
          style="display: inline-block"
        >
          <font-awesome-icon
            :icon="['fal', 'bug']"
            class="account-icon"
            style="display: inline-block"
          />
          <span
            class="ml-2"
            style="display: inline-block; text-decoration: underline"
          >
            Bug Report
          </span>
        </CDropdownItem>
      </div>
      <!-- END CCR User Tools -->
      <CDropdownDivider />

      <CDropdownItem
        @click.prevent="showAccountModal = true"
        class="custom-dark"
      >
        <CIcon name="cil-user" />Manage Account
      </CDropdownItem>
      <CDropdownItem @click.prevent="logout" class="custom-dark">
        <CIcon name="cil-lock-locked" />Log Out
      </CDropdownItem>
    </CDropdown>
    <customModal
      id="userModal"
      title="Manage Account"
      :show.sync="showAccountModal"
      :centered="true"
      :backdrop="true"
      :closeOnBackdrop="false"
      width="70%"
      :CCRColoBrand="true"
    >
      <ManageAccount
        v-if="showAccountModal"
        @hide-modal="showAccountModal = false"
        style="padding: 10px"
      />
    </customModal>

    <ManageAccess
      v-if="showUsersModal"
      :show.sync="showUsersModal"
      :user="user"
      :BU_Brand="BU_Brand"
      DomainApprovalEndpoint="https://api.ccr.net/ColoM360/CompanyDomainList"
      CurrentUserEndpoint="https://api.ccr.net/ColoM360/cxp_UserDetails_View"
      CheckDomainExists="https://api.ccr.net/ColoM360/CheckDomainExists"
    />
  </div>
</template>

<script>
import { DxSelectBox } from "devextreme-vue";
import { EventBus } from "../../components/Events";
import ManageAccount from "../../views/siteModals/ManageAccount";

export default {
  name: "TheHeaderDropdownAccnt",
  components: {
    DxSelectBox,
    ManageAccount,
  },
  props: {
    user: Object,
    companyList: Array,
  },
  data() {
    return {
      showAccountModal: false,
      showUsersModal: false,
      firstLoad: true,
      BU_Brand: {
        BU_RecID: 2,
        PrimaryColor: "#0066b0",
        BU_API_Folder: "ColoM360",
      },
    };
  },
  computed: {
    username: function () {
      return `${this.user.FirstName} ${this.user.LastName}`;
    },
    userInitials: function () {
      return `${this.user.FirstName.slice(0, 1)}${this.user.LastName.slice(
        0,
        1
      )}`;
    },
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    ShowUserBack() {
      // Userback.open("bug");
      if (window.Userback && typeof window.Userback.open === 'function') {
        window.Userback.open('bug');
      }
    },
    logout() {
      // this.$cookies.remove('savedUser');
      this.$auth.logout({ returnTo: `${window.location.origin}` });
    },
    changeCompany: function (e) {
      this.$auth.user.UserDetails.Company_Name = e.selectedItem.Company_Name;
      this.$auth.user.UserDetails.Company_RecID = e.selectedItem.Company_RecID;
      this.$cookies.set("savedUser", this.$auth.user.UserDetails, "24h");
      let isCcrCompany =
        e.selectedItem.Company_RecID == 2 &&
        e.selectedItem.Contact_Company_RecID == 2;
      isCcrCompany
        ? EventBus.$emit("ccr-company-changed")
        : EventBus.$emit("nonccr-company-changed");
      EventBus.$emit("update-channel-count");

      if (!this.firstLoad) {
        //console.log('Pushing to home');
        this.$router.push({ path: "/" }).catch((err) => {});
        //this.$router.push('https://' + window.location.hostname);
      }

      this.$axiosPlugin.setConfig({
        headers: {
          Authorization: `Bearer ${this.user.id_token}`,
        },
      });
      if (this.user.Contact_Company_RecID != this.user.Company_RecID) {
        this.$axiosPlugin.setConfig({
          headers: {
            Authorization: `Bearer ${this.user.id_token}`,
            CompanyID: `${this.user.Company_RecID}`,
          },
        });
      }
      // this.$axiosPlugin.setConfig({
      //   headers: {
      //     Authorization: `Bearer ${this.user.id_token}`,
      //     CompanyID: `${this.user.Company_RecID}`,
      //   },
      // });

      this.firstLoad = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.CompanySelectBox {
  // background-color: #373737;
  color: transparent;
  margin-top: 14px;
}
.account-icon {
  font-size: 16px;
}
.CompanySelectBox:active {
  background-color: transparent;
}

.containerMain > div {
  display: inline-block;
  margin: 10px;
}
.c-icon {
  margin-right: 0.3rem;
}

.user-icon {
  background-color: #ecf0f5;
  //background-color: cyan;
  color: #000;
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

.user-icon:hover {
  background-color: rgb(60, 75, 100);
}

.user-initials {
  font-size: 15px;
  line-height: 30px;
  text-align: center;
}

.user-details {
  text-align: center;
  padding: 10px;
  .username {
    font-weight: bold;
    font-size: 16px;
  }

  .user-email {
    font-size: 12px;
  }
}
// .custom-dark {
//   color: whitesmoke;
//   background-color: #373737;
// }
.dropdown-divider {
  overflow: visible;
  position: relative;
}
.dividerText {
  color: #8a93a2;
  font-weight: bold;
  font-size: 0.76563rem;
  position: absolute;
  background-color: #fff;
  top: -15px;
  left: 10px;
  padding: 5px;
}
</style>
